import StrategicPlanStatus from "@/components/plan/StrategicPlanStatus";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function StrategicPlanningItem(props) {
    const { strategicPlanning } = props;
    const strategicPlanningId = strategicPlanning.id;

    return (
        <Box>
            <Typography variant="h6">
                <Link
                    component={RouterLink}
                    to={`/strategic-plannings/${strategicPlanningId}`}
                    underline="hover"
                    sx={{ color: "black" }}
                >
                    {strategicPlanning.title}
                </Link>
            </Typography>
            <Box sx={{ marginTop: 1 }}>
                <StrategicPlanStatus strategicPlanning={strategicPlanning} />
            </Box>
        </Box>
    );
}
